import axios from "../axiosClientDMS";

export const getDeviceInfo = async (
  TcCode: any,
  SiteCode: any,
  BlockCode: any,
  DeviceId: any,
  PageNumber: any,
  PageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/DeviceInfo`, {
    params: {
      TcCode,
      SiteCode,
      BlockCode,
      DeviceId,
      PageNumber,
      PageSize,
      searchText,
      SortBy,
      SortDirection,
    },
    signal,
  });

  return res?.data;
};

export const messageExchangeList = async (
  TcCode: any,
  SiteCode: any,
  BlockCode: any,
  FromDate: any,
  DeviceId: any,
  PageNumber: any,
  PageSize: any,
  SortBy: any,
  SortDirection: any,
  SearchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/MessageExchangeList`, {
    params: {
      TcCode,
      SiteCode,
      BlockCode,
      FromDate,
      DeviceId,
      PageNumber,
      PageSize,
      SortBy,
      SortDirection,
      SearchText,
    },
    signal,
  });

  return res?.data;
};

/* export const getAlerts = async (
  PageNumber: any,
  pageSize: any,
  StartDate: any,
  EndDate: any,
  deviceCode: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/GetDeviceAlertList`, {
    params: {
      PageNumber,
      pageSize,
      StartDate,
      EndDate,
      deviceCode,
      searchText,
      SortBy,
      SortDirection,
    },
    signal,
  });

  return res?.data;
}; */

/* export const getDeviceAlertList = async (
  PageNumber: any,
  PageSize: any,
  TcCode: any,
  SiteCode: any,
  BlockCode: any,
  DeviceId: any,
  SortBy: any,
  SortDirection: any,
  StartDate: any,
  EndDate: any,
  SearchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/GetDeviceAlertList`, {
    params: {
      PageNumber,
      PageSize,
      TcCode,
      SiteCode,
      BlockCode,
      DeviceId,
      SortBy,
      SortDirection,
      StartDate,
      EndDate,
      SearchText,
    },
    signal,
  });

  return res?.data;
};
 */
